export default {
    //HANDLE SOME CAVEAT IN THE APP...
    async mounted() {
        if (this.$auth.isAuthenticated) {
            if(!this.$auth.userKnown && !this.$auth.loading){
                this.$auth.getUser();
            }
        }
    }
}